<template>
<router-view />
</template>

<script>
export default {
  name: 'Operations',
  routeInfo: {
    label: '数据运维'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/08Operations/index.vue